(() => {
  const previousFocus = new WeakMap();
  function close(dialog) {
    dialog.close();
    document.body.classList.remove('br-dialog-open');
    previousFocus.get(dialog)?.focus();
  }
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-br-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.brOpen);
      if (dialog && !dialog.open) {
        previousFocus.set(dialog, opener);
        dialog.showModal();
        document.body.classList.add('br-dialog-open');
      }
    }
    const closer = event.target.closest('[data-br-close]');
    if (closer) close(closer.closest('dialog'));
    if (event.target.matches('dialog.br-dialog')) {
      const r = event.target.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close(event.target);
    }
    document.querySelectorAll('.br-mega[open]').forEach(details => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.br-mega[open]').forEach(d => {d.open = false; d.querySelector('summary').focus();});
  });
  function init(root = document) {
    root.querySelectorAll('dialog.br-dialog:not([data-br-ready])').forEach(dialog => {
      dialog.dataset.brReady = 'true';
      dialog.addEventListener('close', () => { document.body.classList.remove('br-dialog-open'); previousFocus.get(dialog)?.focus(); });
    });
    if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.remove('br-waiting'); observer.unobserve(entry.target); }
      }), { threshold: 0.05 });
      root.querySelectorAll('.br-section-heading,.br-category,.br-editorial-copy,.br-statement').forEach(el => {
        el.classList.add('br-reveal', 'br-waiting'); observer.observe(el);
      });
    }
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  if (location.hash === '#BrContactForm') {
    document.getElementById('BrContact')?.showModal();
    document.body.classList.add('br-dialog-open');
  }
})();
